/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aloof_Round_Squirrel_BoilInputs */

const fr_aloof_round_squirrel_boil = /** @type {(inputs: Aloof_Round_Squirrel_BoilInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu n'as pas encore de PB pour cet exercice`)
};

/**

* @param {Aloof_Round_Squirrel_BoilInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const aloof_round_squirrel_boil = /** @type {((inputs?: Aloof_Round_Squirrel_BoilInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aloof_Round_Squirrel_BoilInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_aloof_round_squirrel_boil(inputs)
});